module.exports = __webpack_public_path__ + "static/farmacia-roval-3ad31ebbe80302eb55a967f0c0b5dafc.png";